// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31X3l","left":"styles_left__11k43"};